<template>
  <div class="searchable-list">
    <div class="header-search-list">
      <el-input
        :value="query"
        prefix-icon="el-icon-search"
        placeholder="ค้นหาบริการ RJ Services"
        clearable
        @input="handleChangeQuery"
      ></el-input>
      <sc-button
        :disabled="disabled"
        class="add-all-button"
        @click="handleClickAddAllButton"
        >เลือกทั้งหมด</sc-button
      >
    </div>
    <div class="list-body">
      <div v-if="noResult" class="empty">ไม่มีบริการ</div>
      <service-selector-option
        v-for="item in selectableServices"
        :key="item.id"
        v-bind="item"
        :can-select="canSelect"
        class="selected-item"
        @select="handleSelectService(item)"
      ></service-selector-option>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"
import ServiceSelectorOption from "./ServiceSelectorOption"

export default {
  components: {
    ScButton,
    ServiceSelectorOption,
  },
  props: {
    query: {
      type: null,
      default: undefined,
    },
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    selectableServices() {
      return this.value
    },
    canSelect() {
      return !this.disabled
    },
    noResult() {
      return this.value.length === 0
    },
  },
  methods: {
    handleClickAddAllButton() {
      this.$emit("addAll")
    },
    handleSelectService(service) {
      this.$emit("select", service)
    },
    handleChangeQuery(value) {
      this.$emit("queryChange", value)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-list {
  border: $border;
  border-radius: $border-radius;
}

.header-search-list {
  display: grid;
  grid-template-columns: 1fr auto;

  > .add-all-button {
    border: 0;
    border-radius: 0;
    border-bottom: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }

    &[disabled] {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.list-body {
  overflow-y: auto;
  height: 600px;
  > .empty {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
